import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseMessageBusService } from '../../commons/services/base-message-bus.service';
import { LangEnum } from '../../commons/enums/langs.enum';
import { EventsConstants } from '../../commons/constants/event-constants';
import { BaseLocalStorageService } from '../../commons/services/base-local-storage.service';
import { LocalStorageConstants } from '../../commons/constants/local-storage-constants';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
/**
 * Clase para las traducciones de los módulos migrar a microfrontend en un futuro
*/
export class CustomTranslateService {

    constructor (
        private _messageBusService: BaseMessageBusService,
        private _baseLocalStorageService: BaseLocalStorageService,
        public _translateService: TranslateService
    ) {
        this.defineLanguage();
    }

    load(): void {
        this.changeExternalLang();
    }

    getText(key: string): string {
        return this._translateService.instant(key);
    }

    async getTextAsync(key: string): Promise<string> {
        return await this._translateService.get(key).toPromise();
    }

    getTextObservable(key: string): Observable<string>  {
        return this._translateService.get(key);
    }

    setLangEs(): void {
        this.changeLanguage(LangEnum.ES);
    }

    setLangEn(): void {
        this.changeLanguage(LangEnum.EN);
    }

    private changeExternalLang(): void {
        window.removeEventListener(EventsConstants.CHANGE_EXTERNAL_LANGUAGE, (e: Event) => {const detail = (<CustomEvent>e).detail});
        window.addEventListener(EventsConstants.CHANGE_EXTERNAL_LANGUAGE, (e: Event) => {const detail = (<CustomEvent>e).detail});
    }

    private changeLanguage(lang: LangEnum): void {
        if(this._translateService.defaultLang !== lang) {     
            this.saveDefaultLang(lang);
            this._messageBusService.dispatchEventWithData(EventsConstants.CHANGE_LANGUAGE_FROM_SHELL, lang);
        }
    }

    private saveLangs(langs: LangEnum[]): void {
        this._baseLocalStorageService.setObject(LocalStorageConstants.Langs,langs);
    }

    private saveDefaultLang(lang: string): void {
        this._translateService.setDefaultLang(lang);        
        this._baseLocalStorageService.setString(LocalStorageConstants.CurrentLang, lang);
    }
    
    private defineLanguage(): void {
        const langs = [LangEnum.EN, LangEnum.ES];
        this.saveLangs(langs);
        this._translateService.addLangs(langs);
        const browserLang = this._translateService.getBrowserLang() || LangEnum.EN;
        if (!langs.find(lang => lang == browserLang)) return this.saveDefaultLang(LangEnum.EN);
        this.saveDefaultLang(browserLang);
    }

}